// Custom query string generator
// Takes an object with values and makes a query string with duplicate keys.
// params={"subjects": [1,2], "groups": [1]} --> "subjects=1&subjects=2&groups=1"

type ParamValue = string | number | boolean;
type Params = Record<string, ParamValue | ParamValue[]>;

const createQueryString = (params?: Params): string => {
  if (!params) return '';

  const parts: string[] = [];

  Object.keys(params).forEach(key => {
    const value = params[key];

    if (Array.isArray(value)) {
      value.forEach(param => {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(param))}`);
      });
    } else if (value !== undefined && value !== null) {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
  });

  return parts.join('&');
};

export default createQueryString;
